import { provideBusyStateStream } from '@frontend-site/shared/core';
import { RouterStoreService } from './router-store.service';

export const routerStoreBusyStateProvider = provideBusyStateStream({
    deps: [RouterStoreService],
    useFactory: (routerStore: RouterStoreService) => routerStore.busy$
});
